<template>
  <div class="box">
    <div class="study-ul" v-if="list2.length > 0">
      <div class="study-li" v-for="(item, index) in list2" :key="index" @click="onClickRoute(item)">
        <div class="study-text">
          <div class="study-title">{{ item.content }}</div>
          <div class="study-time">
            <div class="study-left">{{ item.createTimeFormat }}</div>
          </div>
        </div>
        <div class="study-video">
          <img v-if="item.information && item.information.image != undefined && item.information.image.url != undefined" :src="item.information.image.url" />
          <img class="course-img-empty" v-else src="@/assets/images/logo-img-two.png" alt="">
        </div>
      </div>
    </div>
    <empty class="empty-margin" v-if="list2.length <= 0"></empty>
    <el-pagination class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick" />
  </div>
</template>

<script>
import empty from "@/components/empty/index";
export default {
  name: "InProgress",
  components: { empty },
  props: {
    list2: {
      type: Array,
      default: []
    },
    page: {
      type: Object,
      default: () => {
        return {
          number: 1,
          limit: 10,
          total: 0,
        }
      }
    }
  },
  data() {
    return {
      appPage: {
        NEWS: 'NewsDetails',
        COURSE: 'CourseDetails',
        GUIDE_CONSENSUS: 'NewsDetailsThree',
        SCIENCE: 'NewsDetailsTwo',
        POST: 'ForumCenterDetails',
      }
    }
  },
  methods: {
    onClickRoute(value) {
      if(value.categories == "POST") {
        this.$router.push({ path: `/${this.appPage[value.categories]}/${value.note.id}` });
      }else {
        this.$router.push({ path: `/${this.appPage[value.categories]}/${value.information.id}` });
      }
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  }
};
</script>

<style scoped lang="less">
.study-li {
  cursor: pointer;
}

.study-video {
  width: 70px !important;
  height: 70px !important;
}

.study-text {
  margin-left: 0 !important;
  margin-right: 12px;
}

/deep/.el-input__inner {
  height: 32px;
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/CommentList.vue